import axios from "axios";

import { GET_TRANSACTIONS_ERROR, GET_TRANSACTIONS_LIST } from "./types";

//list
export const getTransactions = (page) => async (dispatch) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_SITE_URL + `/v2/transactions/${page}`
    );

    dispatch({
      type: GET_TRANSACTIONS_LIST,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;
    dispatch({
      type: GET_TRANSACTIONS_ERROR,
      payload: { msg: errors[0].msg },
    });
    return errors;
  }
};

//invoice

export const invoiceDetail = (id) => async (dispatch) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_SITE_URL + `/v2/transactions/invoice/${id}`
    );
    console.log(id);
    return res.data;
  } catch (err) {
    return 0;
  }
};

export const Download_Invoice_PDF = (obj) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
    responseType: "blob", // Ensures the response is treated as a binary blob
  };

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_SITE_URL}/v2/adminLogin/generate-pdf`,
      obj,
      config
    );
    if (response) {
      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "invoice.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } else {
      console.error("No PDF data returned:", response);
    }
  } catch (error) {
    console.error("Error generating PDF:", error);
  }
};

export const getTransactionsBySearch = (formData, page) => async (dispatch) => {
  try {
    console.log(formData);
    var queryString = "";
    if (
      formData.username !== "" &&
      formData.start_date !== "" &&
      formData.endDate !== ""
    ) {
      queryString = `?username=${formData.username}&startDate=${formData.start_date}&endDate=${formData.end_date}`;
    } else if (
      formData.username == "" &&
      formData.start_date !== "" &&
      formData.endDate !== ""
    ) {
      queryString = `?startDate=${formData.start_date}&endDate=${formData.end_date}`;
    } else if (formData.transaction_id != "") {
      queryString = `?transaction_id=${formData.transaction_id}`;
    }
    const res = await axios.get(
      process.env.REACT_APP_SITE_URL +
        `/v2/transactions/search/${page}${queryString}`
    );

    dispatch({
      type: GET_TRANSACTIONS_LIST,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;
    dispatch({
      type: GET_TRANSACTIONS_ERROR,
      payload: { msg: errors[0].msg },
    });
    return errors;
  }
};
